import { DEFAULT_PROFILE, QueryKey } from 'common-types';

type TStrapiListFilters = {
  locale?: string | null;
  filters?: Record<string, unknown>;
  sort?: string | string[];
  pageSize?: number;
  profile?: string;
};

export const insightsQueryKeys = {
  articles: ({ locale, filters, sort, pageSize, profile }: TStrapiListFilters = {}): readonly unknown[] => [
    QueryKey.ARTICLES,
    locale ?? null,
    filters ?? null,
    sort ?? null,
    pageSize ?? 25,
    profile ?? DEFAULT_PROFILE,
  ],

  collections: ({ locale, filters, sort, pageSize, profile }: TStrapiListFilters = {}): readonly unknown[] => [
    QueryKey.COLLECTIONS,
    locale ?? null,
    filters ?? null,
    sort ?? null,
    pageSize ?? 25,
    profile ?? DEFAULT_PROFILE,
  ],

  categories: ({ locale, filters, sort, pageSize, profile }: TStrapiListFilters = {}): readonly unknown[] => [
    QueryKey.CATEGORIES,
    locale ?? null,
    filters ?? null,
    sort ?? null,
    pageSize ?? 100,
    profile ?? DEFAULT_PROFILE,
  ],

  homeInsightsCategories: ({
    locale,
    filters,
    sort,
    pageSize,
    profile,
  }: TStrapiListFilters = {}): readonly unknown[] => [
    QueryKey.HOME_INSIGHTS_CATEGORIES,
    locale ?? null,
    filters ?? null,
    sort ?? null,
    pageSize ?? 100,
    profile ?? DEFAULT_PROFILE,
  ],

  collection: ({ id, locale }: { id: string; locale?: string | null }): readonly unknown[] => [
    QueryKey.COLLECTIONS,
    'single',
    id,
    locale ?? null,
  ],

  tags: ({ locale }: { locale?: string | null } = {}): readonly unknown[] => [QueryKey.TAGS, locale ?? null],

  mostLikedArticles: ({ count, excludeIds }: { count: number; excludeIds?: string[] }): readonly unknown[] => [
    QueryKey.ARTICLES,
    'most-liked',
    count,
    excludeIds ?? [],
  ],

  articleLikes: (userId: string): readonly unknown[] => [QueryKey.ARTICLE_LIKES, userId],

  bookmarks: (userId: string): readonly unknown[] => [QueryKey.BOOKMARKS, userId],

  bookmarkedArticles: (articleIds: string[]): readonly unknown[] => [QueryKey.BOOKMARKED_ARTICLES, articleIds],

  bookmarkedCollections: (collectionIds: string[]): readonly unknown[] => [
    QueryKey.BOOKMARKED_COLLECTIONS,
    collectionIds,
  ],
} as const;
